import React from 'react';
import styled from '@emotion/styled';
import ReactMarkdown from 'react-markdown';

const Container = styled.div`
  min-height: 100vh;
  background-color: #f5f5f7;
  padding: 2rem;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background: white;
  padding: 2rem;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  flex: 1;
`;

const Title = styled.h1`
  color: #1d1d1f;
  margin-bottom: 2rem;
  font-size: 2rem;
  text-align: center;
`;

const MarkdownContainer = styled.section`
  margin-bottom: 2rem;
  h1 {
    color: #1d1d1f;
    margin-bottom:0.5rem;
    font-size: 1.5rem;
  }
  h2 {
    color: #1d1d1f;
    margin-bottom: 0.5rem;
    font-size: 1.0rem;
  }

  p {
    color: #6e6e73;
    line-height: 1.6;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
  }
`;

const Footer = styled.footer`
  text-align: center;
  padding: 1rem 0;
  color: #86868b;
  font-size: 0.9rem;
`;

function ImgConvertPrivacyPolicyJa() {
  const currentYear = new Date().getFullYear();
  const markdownContent = `
 # プライバシーポリシー

「画像フォーマット変換アプリ」（以下「本アプリ」といいます。）は、ユーザーのプライバシーを尊重し、個人情報の保護に最大限の注意を払っております。本アプリではユーザーの個人情報を収集せず、また、ユーザーのデータを保護するための措置を講じております。本プライバシーポリシー（以下「本ポリシー」といいます。）は、本アプリにおける情報の取り扱いについて定めたものです。

## 第1条（個人情報の収集および管理方針）

本アプリでは、ユーザーからの個人情報（氏名、住所、電話番号など）を一切収集いたしません。アプリ内のすべての機能は、個人情報の収集を行わないことを前提に設計されています。また、ユーザーのプライバシー保護のため、個人情報保護法に基づき、個人を特定できる情報の収集や保存は一切行いません。

## 第2条（画像データの取り扱い）

本アプリでは、ユーザーが変換する画像データはすべてユーザーの端末内でのみ処理され、アプリ外部のサーバー等に送信されることはありません。画像の変換処理はすべてローカルで行われ、変換前後の画像データは端末内にのみ保存されます。本アプリおよび開発元では、ユーザーの画像データに一切アクセスいたしません。

## 第3条（広告配信）

本アプリでは、Google AdMobを通じた広告配信を行っています。広告配信の過程において、Googleが提供するシステムにより広告配信の最適化のためのデータが自動的に収集される場合がありますが、これらのデータはGoogleのプライバシーポリシーに従って管理されます。本アプリでは、広告配信に関連する個人情報は一切保持しません。詳細については、Googleのプライバシーポリシーをご参照ください。

## 第4条（プライバシーポリシーの変更）

本アプリは、本ポリシーの内容を随時見直し、ユーザーのプライバシー保護の向上を図るため、法令の改正やアプリ機能の変更などに応じて本ポリシーを変更することがあります。変更があった場合、最新のプライバシーポリシーを本アプリ内に掲載することによりユーザーへ通知し、掲載と同時に効力を生じるものとします。ユーザーは、定期的に本ポリシーをご確認いただきますようお願いいたします。

## 第5条（お問い合わせ窓口）

本ポリシーに関するお問い合わせやご不明な点については、下記の連絡先までご連絡ください。

Email: linappworks@gmail.com
  `;

  return (
    <Container>
      <Content>
        <Title>Privacy Policy</Title>
        <MarkdownContainer>
          <ReactMarkdown>{markdownContent}</ReactMarkdown>
        </MarkdownContainer>
      </Content>
      <Footer>
        <p>© {currentYear} linappworks. All rights reserved.</p>
        <p>Contact us: linappworks@gmail.com</p>
      </Footer>
    </Container>
  );
}

export default ImgConvertPrivacyPolicyJa; 